/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const photo_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#photo_medium_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m5 17 3.435-4.22c.492-.606 1.425-.73 2.083-.275.056.039.11.081.16.127l1.018.94 3.274-4.023c.493-.606 1.426-.73 2.084-.275.112.078.213.17.297.275L20 12.804M1 17h22M2.467 23C1.657 23 1 22.343 1 21.533V2.467C1 1.657 1.657 1 2.467 1h19.066C22.343 1 23 1.657 23 2.467v19.066c0 .81-.657 1.467-1.467 1.467H2.467ZM7.56 5.44a1.5 1.5 0 1 1-2.122 2.12A1.5 1.5 0 0 1 7.56 5.44Z"
      />
    </g>
    <defs>
      <clipPath id="photo_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default photo_medium
